export default {
  name: 'my-video-button',
  template: `
    <button @click="openVideo()" class="o-link--btn">
      <span class="o-link--icon__text"><slot>View video</slot></span>
    </button>
  `,
  props: {
    videoCode: {
      type: String,
      required: true
    }
  },
  computed: {
    videoSrc () {
      return (/[a-z]/.test(this.videoCode.toLowerCase())) ? 'https://www.youtube.com/embed/' + this.videoCode : 'https://player.vimeo.com/video/' + this.videoCode
    }
  },
  methods: {
    openVideo () {
      console.log(this.videoSrc)
      this.$store.commit('setVideo', this.videoSrc)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-video-button.js